// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";

import { fetchCompanyShows } from "../../../store/shows/showsActions";
import { clearSelectedScene } from "../../../store/scenes/scenesSlice";
import { fetchCompanyScenes } from "../../../store/scenes/scenesActions";

export async function showsLoader() {
  const state = store.getState();

  // get current company and studio from state
  const companyUuid = state.companies?.company?.company_uuid;

  if (!companyUuid) {
    // Store the last companyUuid to detect company change in shouldRevalidate
    showsLoader.lastCompanyUuid = null;
    return null;
  }

  // clear state selected scene and studio error
  store.dispatch(clearSelectedScene());

  // Fetch shows/scenes for the current company
  await Promise.all([
    store.dispatch(fetchCompanyShows(companyUuid)),
    store.dispatch(fetchCompanyScenes(companyUuid)),
  ]);

  return null;
}

showsLoader.hydrate = true;
